export const projectSettings = {
  baseURL: "https://solarpaketapi.solaravm.com/api",
  //baseURL: "https://localhost:5000",
};
